import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {ModulosConfigService} from '../../core/services/config/modulos-config.service';
import {IframePageComponent} from '../iframe-page/iframe-page.component';

@Component({
  selector: 'app-router-outlet-dynamic',
  templateUrl: './router-outlet-dynamic.component.html'
})

export class RouterOutletDynamicComponent implements OnInit {

  // loaded = false;
  // originalUrl: string;

  constructor(
    // private _activatedRoute: ActivatedRoute, private _router: Router,
    //           private _modulos: ModulosConfigService
  ) {
    // this._router.events.subscribe((val) => {
    //   this.originalUrl = val['url'];
    // });
  }

  ngOnInit() {
    // this._modulos.getPaginasTreinamento()
    //   .subscribe(obj => {
    //     const paginas = obj['paginas'];
    //     let replaceUrl = false;
    //
    //     if (!this.loaded) {
    //       for (const route of paginas) {
    //         route.component = IframePageComponent;
    //         this._activatedRoute.routeConfig.children.push(route);
    //       }
    //
    //       this.loaded = true;
    //       if (this.originalUrl === this._activatedRoute.routeConfig.data['urlOriginal']) {
    //         this._activatedRoute.routeConfig.data['urlOriginal'] = this._activatedRoute.routeConfig.path + '/' + this._activatedRoute.routeConfig.children[0]['path'];
    //         replaceUrl = true;
    //       }
    //       this._router.navigateByUrl(
    //         this._activatedRoute.routeConfig.data['urlOriginal'],
    //         {skipLocationChange: replaceUrl});
    //       console.log(this._activatedRoute.routeConfig);
    //     }
    //   });
  }

}
